
import { motion } from 'framer-motion';
import { successStories } from '../../../mocks/adoptableCats';

export default function SuccessStories() {
  return (
    <section className="py-12 sm:py-20 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-gray-900 mb-3">
            Happy <span className="text-accent">Tails</span> 🐾
          </h2>
          <p className="font-body text-gray-500 text-sm sm:text-base max-w-xl mx-auto">
            Real stories from families who found their purr-fect match through adoption.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-6">
          {successStories.map((story, index) => (
            <motion.div
              key={story.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <div className="relative w-full h-52 sm:h-60 overflow-hidden">
                <img
                  src={story.image}
                  alt={`${story.name} - adopted cat success story`}
                  title={`${story.name} found a forever home`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 sm:p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="font-heading font-bold text-lg text-gray-900">{story.name}</span>
                  <span className="text-xs font-body text-gray-400">&middot; adopted by {story.adopter}</span>
                </div>
                <p className="font-body text-sm text-gray-600 leading-relaxed mb-3 italic">
                  &ldquo;{story.story}&rdquo;
                </p>
                <p className="font-body text-xs text-gray-400 flex items-center gap-1">
                  <i className="ri-home-heart-line text-accent text-sm w-4 h-4 flex items-center justify-center"></i>
                  From {story.shelter}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
